import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch, reactive, computed } from 'vue';
import { getLicensedAgents, LicensedAgent } from '../api/getLicensedAgents';
import Header from '../components/Header.vue';
import DataTable from '../components/DataTable.vue';
// TODO: Make requirements and refactor this component
import QBusinessTimePeriodSelect from '../../../components/utils/QBusinessTimePeriodSelect.vue';
import { useRoute, useExportToCSV } from '../../shared';
import { useUser } from '../../../composables/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'LicensedCandidates',
  setup(__props) {

const route = useRoute();
const user = useUser()

const filters = reactive({
  search: '',
  datePeriod: {
    endDateFormat: (route.query.endDate || null) as string | null,
    startDateFormat: (route.query.startDate || null) as string | null,
    period: (route.query.timePeriod || null) as string | null,
  }
})

const data = ref<LicensedAgent[] | null>(null)

const searchedData = computed(() => {
	if (filters.search === '') { return data.value }

	return data.value?.filter((item) => {
		return item.UplineAgent.toLowerCase().includes(filters.search.toLowerCase())
			|| item.Recruit.toLowerCase().includes(filters.search.toLowerCase())
			|| item.KeyLeader.toLowerCase().includes(filters.search.toLowerCase())
			|| item.BaseshopOwner.toLowerCase().includes(filters.search.toLowerCase())
			|| item.SFGDirect.toLowerCase().includes(filters.search.toLowerCase())
			|| item.ContractSubmitDate.toLowerCase().includes(filters.search.toLowerCase())
	}) || null
})

onMounted(async () => {
  data.value = await getLicensedAgents(filters, user.value.AgentCode)
})

watch(() => filters.datePeriod, async () => {
  data.value = null
  data.value = await getLicensedAgents(filters, user.value.AgentCode)
}, { deep: true })

const { exportToCSV } = useExportToCSV(['UplineAgent', 'Recruit', 'KeyLeader', 'BaseshopOwner', 'SFGDirect', 'ContractSubmitDate', 'Licensed'])

const exportResults = () => {
	const date = filters.datePeriod.startDateFormat ? ` ${filters.datePeriod.startDateFormat} - ${filters.datePeriod.endDateFormat}` : ''
	exportToCSV(searchedData.value || [], 'Licensed Candidates' + date)
}

return { __sfc: true,route, user, filters, data, searchedData, exportToCSV, exportResults, Header, DataTable, QBusinessTimePeriodSelect }
}

})